import React from 'react'

import catalogTypes from '../../catalog/Root/catalog-types'
import GoodPageWithData from './data'

const GoodPageRenderer = ({
  location: {
    search,
    state
  },
  match: {
    params: {goodIdStr}
  },
  history: {
    goBack
  },
  ...otherProps
}) => {
  const fromMatch = search.match(/from=([^&]*)/)
  const fromStr = fromMatch && fromMatch.length > 1 ? fromMatch[1] : ''
  const [fromCatalogTypeStr, fromCategoryIdStr] = fromStr.split('-')

  const referrerCatalogType = catalogTypes[fromCatalogTypeStr] || null
  const referrerCategoryId = parseInt(fromCategoryIdStr) || null

  const props = {
    ...otherProps,
    goodId: parseInt(goodIdStr) || -1,
    referrerCatalogType,
    referrerCategoryId,
    goBack: state && state.canGoBack ? goBack : null
  }

  return <GoodPageWithData {...props}/>
}

export default GoodPageRenderer
